export default "__VITE_ASSET__Cxa2W8WM__"